import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class FormDebug extends Component {
  static propTypes = {
    values: PropTypes.object,
    errors: PropTypes.object
  }

  render() {
    return (
      <div className="row">
        <div className="col-xs-6">
          <h3>Values</h3>
          <pre>{JSON.stringify(this.props.values, null, 2)}</pre>
        </div>
        <div className="col-xs-6">
          <h3>Errors</h3>
          <pre>{JSON.stringify(this.props.errors, null, 2)}</pre>
        </div>
      </div>
    )
  }
}
